export default __webpack_public_path__ + "static/media/wave4.258b17c5.svg";